const ModalRechazoTipos = {
    data: {
        MOSTRAR_RECHAZO: "MOSTRAR_RECHAZO",
        MOTIVO_DE_RECHAZO: "MOTIVO_DE_RECHAZO",
        REQUEST_RECHAZO: "REQUEST_RECHAZO",
        LOAD_POSTS_REQUEST_RECHAZO: "LOAD_POSTS_REQUEST_RECHAZO",
        ERROR_API_RECHAZO:"ERROR_API_RECHAZO",
        MOTIVOS_DISPONIBLES:"MOTIVOS_DISPONIBLES"
    }
}

export default ModalRechazoTipos;